<template>
  <div>
    <b-navbar sticky class="exam__navbar">
      <b-navbar-brand :to="is_room ? {name: 'thi-thu-lich-su'} : { name: 'exam-detail', params: { id, slug } }" class="exam__back">
        <fa-icon icon="long-arrow-alt-left" /> Trở lại
      </b-navbar-brand>

      <b-navbar-nav>
        <b-nav-text class="exam__title d-none d-sm-block">{{ examDetail.name }}</b-nav-text>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-text v-if="isProcessing" class="exam__btn__timer mr-3"><span class="d-none d-sm-block">Tổng thời gian còn lại</span> {{ convertSecondsToTime(currentTotalTime) }}</b-nav-text>
        <b-nav-text v-if="isProcessing" class="exam__btn__finish" @click="submitAnswer">Nộp bài thi</b-nav-text>
      </b-navbar-nav>
    </b-navbar>
    <div v-if="isLoading">
      <div class="text-center my-5" style="min-height: 50vh">
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        
        <div>Loading...</div>
      </div>
    </div>
    <div v-else>
      <b-container fluid>
        <b-row>
          <b-col class="exam__sidebar" cols="12" md="3" lg="3" xl="3">
            <div v-if="isProcessing" class="exam__timer">{{ convertSecondsToTime(currentTime) }}</div>
            <div v-else class="exam__timer">{{ convertSecondsToTime(examDetail.time * 60) }}</div>
            <div class="exam__table-content">
              <template v-for="skill in examIndexList">
                <div :key="skill.id" class="exam__index__skill" v-show="!isProcessing || examState.skill == skill.id">
                  <h4 :class="'exam__index__title' + (examState.skill == skill.id ? ' active' : '')">{{ skill.name }}</h4>

                  <template v-b-scrollspy="{ element: `#scrollspy-${examDetail.id}`, offset: 96 }">
                    <b-container>
                      <b-row no-gutters>
                        <template v-for="item in skill.questions">
                          <b-col :key="item.id" cols="3" lg="2">
                            <div class="text-center">
                              <template v-if="isProcessing">
                                <a :ref="`question-${item.id}`" :href="`#item-${item.number}`" @click="questionIndexClick" class="exam__index__question">{{ item.number }}</a>
                              </template>
                              <template v-else>
                                <span class="exam__index__question">{{ item.number }}</span>
                              </template>
                            </div>
                          </b-col>
                        </template>
                      </b-row>
                    </b-container>
                  </template>
                </div>
              </template>
            </div>
            <div class="exam__end_session">
              <b-button class="exam__btn__finish_session" v-show="isProcessing" @click="finishThisSession">Nộp phần thi này</b-button>  
            </div>
          </b-col>
          <b-col class="exam__primary" cols="12" md="9" lg="9" xl="9">
            <div :id="`scrollspy-${examDetail.id}`" ref="content">
              <div v-if="isProcessing">
                <template v-for="skill in examDataList">
                  <div :key="skill.id" class="exam__skill__wrapper" v-show="skill.id == examState.skill">
                    <div class="exam__skill__title">{{ skill.name }}</div>

                    <template v-for="part in skill.parts">
                      <div :key="part.id" class="exam__part__wrapper">
                        <div class="exam__part__title">{{ part.name }}</div>
                        <div v-html="part.description" class="exam__part__description mb-1"></div>
                        
                        <template v-for="question in part.questions">
                          <template v-if="question.typeEnum === 'single'">
                            <QuestionSingle :key="question.id" :id="`item-${question.number}`" :data-id="question.id" :data-type="`${question.typeEnum}-${question.type}`" :parent="null" :question="question" v-on:selectAnswer="updateAnswer" :editable="true" :answer="null" />
                          </template>
                          <template v-else>
                            <QuestionGroup :key="question.id" :question="question" v-on:selectAnswer="updateAnswer" :editable="true" :response="null" :class="'question__group__wrapper' + ((examState.question == question.id) ? ' question__group__wrapper--active' : '')" />
                          </template>
                        </template>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
              <div v-else>
                <div class="text-center my-5">
                  <b-button class="exam__btn__start" @click="startResponse">Bắt đầu làm bài</b-button>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import { APP_CONFIG } from '@/utils/constants'
import { STORE_KEY } from '../_store/constants'
import QuestionSingle from './QuestionSingle'
import QuestionGroup from './QuestionGroup'

export default {
  name: 'ExamResponse',
  components: {
    QuestionSingle,
    QuestionGroup
  },
  data() {
    return {
      id: this.$route.params.id,
      slug: this.$route.params.slug,
      cdnUrl: APP_CONFIG.cdnUrl,
      isProcessing: false,
      dataAnswer: [],
      isCountdown: false,
      audioPlayer: null,
      currentData: [],
      currentSkill: null,
      currentTotalTime: 0,
      currentTime: 0,
      isFinish: false,
      is_room: false
    }
  },
  computed: {
    ...mapGetters({
      examDetail: `${STORE_KEY}/examDetail`,
      examIndexList: `${STORE_KEY}/examIndexList`,
      examDataList: `${STORE_KEY}/examDataList`,
      examAudioList: `${STORE_KEY}/examAudioList`,
      examState: `${STORE_KEY}/examState`,
      isLoading: `${STORE_KEY}/isLoading`,
    })
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ['getExamDetail', 'postExamSubmit', 'setExamStateSkill', 'setExamStatePart', 'setExamStateQuestion']),
    convertSecondsToTime(sec) {
      var hrs = Math.floor(sec / 3600)
      var min = Math.floor((sec - (hrs * 3600)) / 60)
      var seconds = sec - (hrs * 3600) - (min * 60)
      seconds = Math.round(seconds * 100) / 100
      
      var result = (hrs < 10 ? "0" + hrs : hrs)
      result += ":" + (min < 10 ? "0" + min : min)
      result += ":" + (seconds < 10 ? "0" + seconds : seconds)

      return result
    },
    questionIndexClick(e) {
      e.preventDefault()
      const href = e.target.getAttribute('href')
      const el = href ? document.querySelector(href) : null
      if (el) {
        window.scrollTo(0, el.offsetTop - 15)
      }
    },
    playAudio(audioList) {
      try {
        if(audioList.length) {
          let audioPath = audioList.shift()
          console.log(`Playing: [${audioPath.type}] - ${audioPath.path}`)

          // Play audio
          this.audioPlayer = new Audio(this.cdnUrl + audioPath.path);

          this.audioPlayer.play();
          
          this.audioPlayer.onended = () => {
            this.playAudio(audioList);
          };

          // Active the question
          if (audioPath.type === 'question') {
            this.setExamStateQuestion(audioPath.id)
          } else if (audioPath.type === 'question-group') {
            this.setExamStateQuestion(audioPath.id)
          } else {
            this.setExamStateQuestion(null)
          }
        } else {
          this.audioPlayer.pause();
          this.audioPlayer = null;
        }
      } catch (error) {
        axios.post(`${APP_CONFIG.apiUrl}/auth/logs`, {
            msg: String(error)
        })
      }
    },
    startResponse() {
      // Change processing status
      this.isProcessing = true

      // Update object tracking
      this.currentData = this.examDataList.reduce((res, cur) => {
        return res.concat(cur)
      }, [])
      this.currentSkill = this.currentData.shift()
      this.setExamStateSkill(this.currentSkill.id)

      // Play Audio
      if (this.currentSkill.isListening) {
        this.playAudio(this.examAudioList)
      } else {
        this.setExamStateQuestion(null)
      }

      // Set time
      this.currentTotalTime = this.examDetail.time * 60
      this.currentTime = this.currentSkill.time * 60

      this.isCountdown = setInterval(function() {        
        // Check if timer = 0
        if (this.currentTime <= 0) {

          // Delete audio object
          if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer = null;
          }

          if (this.currentTotalTime >  0) {
            // Update object tracking
            this.currentSkill = this.currentData.shift()
            this.setExamStateSkill(this.currentSkill.id)
            this.currentTime = this.currentSkill.time * 60
            // Play Audio
            if (this.currentSkill.isListening) {
              this.playAudio(this.examAudioList)
            }
          }

        } else {
          // Countdown timer
          this.currentTime = this.currentTime - 1
        }

        if (this.currentTotalTime <= 0) {
          this.isProcessing = false
          this.postExamSubmit({ id: this.id, data: { data: this.dataAnswer }, is_room: this.is_room });
        } else {
          this.currentTotalTime = this.currentTotalTime - 1
        }
        
      }.bind(this), 1000);
    },
    finishThisSession() {
      this.$bvModal.msgBoxConfirm('Bạn có chắc chắn muốn nộp phần thi này?', {
        title: 'Xác nhận nộp phần thi!',
        okVariant: 'danger',
        okTitle: 'Nộp ngay',
        cancelTitle: 'Tiếp tục làm bài',
      })
      .then(value => {
        if (value) {
          // Delete audio object
          if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer = null;
          }
          if (this.currentTotalTime >  0 && this.currentData.length > 0) {
            // Update object tracking
            this.currentSkill = this.currentData.shift()
            this.setExamStateSkill(this.currentSkill.id)
            this.currentTime = this.currentSkill.time * 60
            // Play Audio
            if (this.currentSkill.isListening) {
              this.playAudio(this.examAudioList)
            }
          }else{
            if (this.audioPlayer) {
              this.audioPlayer.pause();
              this.audioPlayer = null;
            }
            this.postExamSubmit({ id: this.id, data: { data: this.dataAnswer }, is_room: this.is_room });
          }
        }
      })
      .catch(() => {
        // An error occurred
      })
    },
    updateAnswer(dataAnswer) {
      this.$refs['question-' + dataAnswer.question_id][0].classList.add('exam__index__question--selected');

      let isNew = true;

      this.dataAnswer.forEach(question => {
        if (question.question_id == dataAnswer.question_id) {
          isNew = false;
          
          if (typeof dataAnswer.answer !== 'undefined') {
            question.answer = dataAnswer.answer;
          }

          if (typeof dataAnswer.answer_id !== 'undefined') {
            question.answer_id = dataAnswer.answer_id;
          }
        }
        
      });

      if (isNew) {
        this.dataAnswer.push(dataAnswer);
      }
    },
    submitAnswer() {
      this.$bvModal.msgBoxConfirm('Sau khi "Nộp bài thi" bạn sẽ không thể tiếp tục làm bài thi này. Vui lòng chọn "Nộp phần thi này" để làm phần tiếp theo.', {
        title: 'Xác nhận nộp bài thi!',
        okVariant: 'danger',
        okTitle: 'Nộp ngay',
        cancelTitle: 'Tiếp tục làm bài',
      })
      .then(value => {
        if (value) {
          if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer = null;
          }
          this.postExamSubmit({ id: this.id, data: { data: this.dataAnswer } , is_room: this.is_room});
        }
      })
      .catch(() => {
        // An error occurred
      })
    },
    preventNav(event) {
      if (!this.isFinish) return;

      if (window.confirm('Bạn muốn dừng làm bài thi? Kết quả sẽ không được lưu lại!!!')) {
        this.isFinish = true;
      } else {
        event.preventDefault();
        event.returnValue = "";
      }
    }
  },
  watch: {
    examDetail () {
      this.is_room = this.examDetail.is_room
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.getExamDetail(this.id);
    window.scroll(0,0);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
    if (this.audioPlayer) {
      this.audioPlayer.pause();
      this.audioPlayer = null;
    }
    clearInterval(this.isCountdown);
  }
}
</script>